export const APP_RATE_LAST_DATE_STORAGE_KEY = 'APP_RATE_LAST_DATE';
export const APP_RATE_PENDING_REQUEST_STORAGE_KEY = 'APP_RATE_PENDING_REQUEST';
export const APP_RATE_RECENT_TRANSACTION_COUNT_TO_CONSIDER = 10;
